import React from 'react';

interface ISelectArrowThinProps {
    fill?: string;
    width?: string;
    height?: string;
}

export const SelectArrowThin = ({
    width = '10',
    height = '6',
    fill = 'currentColor',
}: ISelectArrowThinProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 10 6"
        fill="none"
    >
        <path
            d="M9.41126 0.470459L5.29501 4.58671C5.21584 4.66284 5.11027 4.70537 5.00043 4.70537C4.89059 4.70537 4.78502 4.66284 4.70585 4.58671L0.592096 0.472542L0.00292969 1.06171L4.11668 5.17588C4.35495 5.40297 4.67148 5.52965 5.00064 5.52965C5.32979 5.52965 5.64632 5.40297 5.8846 5.17588L10.0004 1.05963L9.41126 0.470459Z"
            fill={fill}
        />
    </svg>
);
